exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".buttons {\n  margin-top: 20px;\n  float: right; }\n\np {\n  margin: 15px; }\n\ninput {\n  color: black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/organisations/components/delete-company/delete-company.component.scss
// module id = 1276
// module chunks = 0